import React from 'react'

const ImageType = ({ typeId, size, alt, style }) =>
{
  if (typeof typeId !== 'number') {
    typeId = 0;
  }

  if (size >= 64) {
    size = 64;
  } else {
    size = 32;
  }

  let url = 'https://image.eveonline.com/Type/' + typeId + '_' + size + '.png';

  return (
    <img style={style} alt={alt} src={url} />
  );
}

export default ImageType
